import { routes } from '@src/modules/shell/configurations/routes'

/* eslint-disable import/prefer-default-export */
export interface MenuItemData {
  title: string
  url?: string
  path?: string | string[]
  counter?: number
  selector: string
  selectorCollapsed?: string
  disabled?: boolean
}

export interface MenuItemDataWithSubItems {
  title: string
  url?: string
  selector: string
  subItems: MenuItemData[]
}

export const selectorSources = `sources`

export const MenuItems: (MenuItemData | MenuItemDataWithSubItems)[][] = [
  [{ title: 'Dashboard', url: 'dashboard', selector: 'dashboard' }],
  [
    { title: 'Alerts', url: 'alerts', selector: 'alerts' },
    { title: 'Changes', url: 'changes', selector: 'changes' },
    { title: 'Guardrails', url: 'guardrails', selector: 'guardrails' },
    { title: 'Compliance', url: 'compliance', selector: 'compliance' },
    { title: 'Unused Access', url: 'unused-access', selector: 'unused-access' }
  ],
  [
    {
      title: 'Sources',
      selector: selectorSources,
      subItems: [
        {
          title: 'Cloud Sources',
          path: [
            `${routes?.accounts?.path}/cloud/:cloud_type/:organization_uid?`
          ],
          url: 'sources/cloud',
          selector: selectorSources
        },
        {
          title: 'IDP Sources',
          url: 'sources/idp',
          path: [`${routes?.accounts?.path}/idp/:cloud_type`],
          selector: selectorSources
        }
      ]
    }
  ],
  [
    { title: 'Networks', url: 'networks', selector: 'networks' },
    { title: 'Objects', url: 'objects', selector: 'objects' },
    { title: 'Identities', url: 'identities', selector: 'identities' },
    { title: 'Privileges', url: 'privileges', selector: 'privileges' },
    { title: 'Reports', url: 'reports', selector: 'reports' }
  ]
]
